import { useSocket } from "../contexts/SocketContext";

const RealtimeBanner = () => {
  const { status, isRealtimeDown, reconnect } = useSocket();

  if (!isRealtimeDown) return null;

  const isReconnecting = status === "connecting";

  return (
    <div className="flex h-8 items-center justify-between gap-3 border-t border-amber-200 bg-amber-50 px-4 text-xs text-amber-800">
      <div className="flex min-w-0 items-center gap-3">
        <span className="relative flex h-2 w-2 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500" />
        </span>
        <span className="truncate">
          <span className="font-medium">Mises à jour en temps réel interrompues.</span> Les nouveaux dossiers n’apparaissent pas automatiquement tant que la connexion n’est pas
          rétablie.
        </span>
      </div>
      <button
        type="button"
        onClick={reconnect}
        disabled={isReconnecting}
        className="shrink-0 rounded-md border border-amber-300 bg-white px-2 py-0.5 font-medium text-amber-800 transition-colors hover:bg-amber-100 disabled:cursor-default disabled:opacity-60"
      >
        {isReconnecting ? "Reconnexion…" : "Réessayer"}
      </button>
    </div>
  );
};

export default RealtimeBanner;
